<ng-container [formGroup]="editorForm">
  <ca-conversation-side-selector [isFilterPanel]="true" formControlName="editor"> </ca-conversation-side-selector>
</ng-container>
